import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { ActiveItemsComponent } from './active-items.component';
import { ActiveItemsService } from './active-items.service';
import { ItemCommonModule } from '../common/item-common.module';

@NgModule({
  imports: [CommonModule, ItemCommonModule, TranslateModule],
  exports: [ActiveItemsComponent],
  declarations: [ActiveItemsComponent],
  providers: [ActiveItemsService],
})
export class ActiveItemsModule {}
